import TOKEN from '../TOKEN';

const createUrl =
  (context) =>
  ({ 0: text, index }) => ({
    type: TOKEN.URL,
    text,
    index,
  });

createUrl.regex = /https?:\/\/\S+/g;

export default createUrl;
